export default class TransactionNotFoundError extends Error {
  constructor (transactionId) {
    super(`Transação ${transactionId} não encontrada`)
    this.name = 'TransactionNotFoundError'
  }
}
